import { supabase } from '@/lib/supabase'
import { SUPPORTED_TIMEFRAMES } from '@/shared/utils/timeframes'

export type RolePushPolicy = {
  role: string
  push_enabled: boolean
  allowed_timeframes: string[]
}

function sanitizeTfs(arr: string[]): string[] {
  const set = new Set(arr.map((t) => String(t).toUpperCase()))
  const out: string[] = []
  for (const t of SUPPORTED_TIMEFRAMES) if (set.has(String(t).toUpperCase())) out.push(t)
  return out
}

export async function getRolePushPolicy(role: string): Promise<RolePushPolicy> {
  const { data, error } = await supabase
    .from('role_push_policies')
    .select('role,push_enabled,allowed_timeframes')
    .eq('role', role)
    .maybeSingle()
  if (error && (error as any).code !== 'PGRST116') throw error
  return {
    role,
    push_enabled: (data as any)?.push_enabled === true,
    allowed_timeframes: sanitizeTfs(((data as any)?.allowed_timeframes || []) as string[]),
  }
}

export async function upsertRolePushPolicy(
  role: string,
  push_enabled: boolean,
  allowed_timeframes: string[],
): Promise<void> {
  const clean = sanitizeTfs(allowed_timeframes)
  const rows = [{ role, push_enabled: !!push_enabled, allowed_timeframes: clean }]
  const { error } = await supabase.from('role_push_policies').upsert(rows as any, { onConflict: 'role' })
  if (error) throw error
}

export function getSupportedTimeframes(): string[] {
  return SUPPORTED_TIMEFRAMES.slice()
}

